var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "nouislider", "../domutils", "./StyleTool"], function (require, exports, nouislider_1, domutils_1, StyleTool_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RangeTool = void 0;
    nouislider_1 = __importDefault(nouislider_1);
    class RangeTool extends StyleTool_1.StyleTool {
        constructor(viewer, id, defaultValue, changeHandler, min = 0, max = 1) {
            super(viewer, id, defaultValue, changeHandler);
            this.min = min;
            this.max = max;
            // must be called
            this.initTool();
        }
        initTool() {
            this.sliderElement = document.createElement('div');
            domutils_1.addClass(this.sliderElement, 'range-slider');
            this.slider = nouislider_1.default.create(this.sliderElement, {
                start: [this.defaultValue],
                connect: true,
                range: {
                    min: this.min,
                    max: this.max,
                },
            });
            this.slider.on('update', (values) => {
                if (values === null || values === void 0 ? void 0 : values[0]) {
                    this.changeHandler(values[0].toString());
                }
            });
        }
        getTool() {
            return this.sliderElement;
        }
    }
    exports.RangeTool = RangeTool;
});
//# sourceMappingURL=RangeTool.js.map